import { render } from "./update.vue?vue&type=template&id=32d7c2fe&scoped=true"
import script from "./update.vue?vue&type=script&lang=js"
export * from "./update.vue?vue&type=script&lang=js"

import "./update.vue?vue&type=style&index=0&id=32d7c2fe&lang=scss&scoped=true"
import "./update.vue?vue&type=style&index=1&id=32d7c2fe&lang=scss"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d7c2fe"]])

export default __exports__